<template>
    <div class="user-table-container">
        <div class="HeaderTab">
             <el-button v-for="item in Child" :key="item.id" size="small" :type="SysType != item.id?'info':'primary'" plain @click="ToggleSysType(item.id)">{{item.system_name}}</el-button>
        </div>
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="TypeVal" @change="ReSetPage" clearable placeholder="申请类型">
                    <el-option v-for="i in RowType" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="SortVal" @change="ReSetPage" clearable placeholder="排序">
                    <el-option label="平均分升序" value="asc"></el-option>
                    <el-option label="平均分降序" value="desc"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="StateVal" @change="ReSetPage" clearable>
                    <el-option v-for="item in QueryList.dianping_sq_status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead"></div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" :tree-props="{children: 'children'}" default-expand-all row-key="id">
            <el-table-column prop="record_number" label="编号" min-width="50"></el-table-column>
            <el-table-column prop="group_name" label="申请类型" min-width="100"></el-table-column>
            <el-table-column prop="record_name" label="申请名称" min-width="100"></el-table-column>
            <el-table-column prop="user_name" label="申请人" min-width="50"></el-table-column>
            <el-table-column prop="admin_name" label="操作人" min-width="50"></el-table-column>
            <el-table-column prop="online_pingfen" label="初审平均分" min-width="60"></el-table-column>
            <el-table-column prop="final_pingfen" label="复审平均分" min-width="60"></el-table-column>
            <el-table-column prop="opinion" label="形审意见" min-width="100"></el-table-column>
            <el-table-column prop="sq_status_name" label="评审阶段" min-width="80">
                <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.sq_status_name}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="sq_status_name" label="评审开关" min-width="70">
                <template slot-scope="scope">
                    <el-switch :disabled="scope.row.sq_status!=9 && scope.row.sq_status!=10" v-model="scope.row.is_dianping_kai" active-color="#13ce66" inactive-color="#ddd"
                    :active-value="1" :inactive-value="0" @change="ToggleState(scope.row)"/>
                </template>
            </el-table-column>
            <el-table-column prop="djs" label="评审倒计时" min-width="100">
                <template slot-scope="scope">
                    <div v-if="scope.row.sq_status==9 && scope.row.djs>0 && scope.row.is_dianping_kai">
                        <Time :seconds="scope.row.djs" @update:seconds="scope.row.djs = $event"/>
                    </div>
                    <div v-if="scope.row.djs<0" class="Red">已超时</div>
                    <div v-if="!scope.row.is_dianping_kai">已暂停</div>
                    <div v-if="scope.row.sq_status==10">已结束</div>
                    <el-button v-throttle v-if="scope.row.sq_status==9" class="BgColor" size="small" @click="SendEmail(scope.row.id)">发送提醒邮件</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="提交时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="140" align="center">
                <template slot-scope="scope" v-if="scope.row.is_dianping_shenhe!=1">
                    <el-tooltip effect="dark" content="完结" placement="top-start">
                        <i v-if="scope.row.sq_status ==10" class="NavIcon el-icon-folder-checked" @click="WanJieSuc(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="不通过" placement="top-start">
                        <i v-if="scope.row.sq_status ==10||scope.row.sq_status ==9" class="NavIcon el-icon-document-delete" @click="NoSuc(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="评审人员查看" placement="top-start">
                        <i class="NavIcon iconfont icon-shenhe" @click="LockPS(scope.row)"></i> 
                    </el-tooltip>
                    <el-tooltip effect="dark" content="收集信息查看" placement="top-start">
                        <i class="NavIcon el-icon-view" @click="LockData(scope.row)"></i>
                    </el-tooltip>
                    <el-popover placement="top" width="100">
                        <div>
                            <div class="TongBuDis JusRight">
                                <el-button type="primary" plain size="mini" @click="LockUserPs(scope.row)">预览</el-button>
                            </div>
                            <div class="TongBuDis">
                                <span>形式审查意见</span> 
                                <el-switch v-model="scope.row.is_xingshi_user_yj" :active-value="1" :inactive-value="0" @change="ToggleTongBu(scope.row)" />
                            </div>
                            <div class="TongBuDis">
                                <span>资料/初审</span>
                                <el-switch v-model="scope.row.is_online_user_yj" :active-value="1" :inactive-value="0" @change="ToggleTongBu(scope.row)" />
                            </div>
                            <div class="TongBuDis">
                                <span>现场/复审</span>
                                <el-switch v-model="scope.row.is_final_user_yj" :active-value="1" :inactive-value="0" @change="ToggleTongBu(scope.row)" />
                            </div>
                            <div class="TongBuDis">
                                <span>点评意见</span>
                                <el-switch v-model="scope.row.is_dianping_user_yj" :active-value="1" :inactive-value="0" @chanDownFile="ToggleTongBu(scope.row)" />
                            </div>
                        </div>
                        <div slot="reference" class="TongBuBtn">
                          <el-tooltip effect="dark" content="意见同步客户" placement="top-start">
                              <i class="NavIcon el-icon-s-promotion"></i>
                          </el-tooltip>
                        </div>
                    </el-popover>
                    <el-tooltip effect="dark" content="下载" placement="top-start">
                        <i class="NavIcon el-icon-download" @click="DownFile(scope.row.id)"></i>
                    </el-tooltip>
                </template>
                <template slot-scope="scope" v-else>
                    <el-tooltip effect="dark" content="审核" placement="top-start">
                        <i class="NavIcon el-icon-s-check" @click="ToggleShenHe(scope.row)"></i>
                    </el-tooltip> 
                    <el-tooltip effect="dark" content="评审人员查看" placement="top-start">
                        <i class="NavIcon iconfont icon-shenhe" @click="LockPS(scope.row)"></i> 
                    </el-tooltip> 
                    <el-tooltip effect="dark" content="收集信息查看" placement="top-start">
                        <i class="NavIcon el-icon-view" @click="LockData(scope.row)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <PingShenInfo :visible="PSBlon" :rowData="PSData" @cancel="PSBlon = false" />
        <PingShenUser :visible="UserPSBlon" :rowData="UserPSData" @cancel="UserPSBlon = false" />
        <FieldMol :visible="NewData.NewBlon" :BaoCun="false" :Type="Type" :rowData="RowData" :newData="NewData" @cancel="$Tools.ResetData(NewData)"/>
        <el-dialog title="项目审核" :visible.sync="ShenHeData.Blon" width="45%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">是否通过：</div>
                <el-radio-group v-model="ShenHeData.Val">
                    <el-radio label="1">通过</el-radio>
                    <el-radio label="2">不通过</el-radio>
                </el-radio-group>
            </div>
            <div class="DigItem" v-if="ShenHeData.Val==2">
                <div class="DigItemTit">驳回原因：</div>
                <el-input class="Wid" type="textarea" :rows="2" placeholder="请输入内容" v-model="ShenHeData.Remark"> </el-input>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(ShenHeData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ShenHeSuc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SysType:"",
                SearchVal:"",
                TypeVal:"",
                StateVal:"",
                SortVal:"",
                QueryList:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Lock',
                NewData:{
                    record_name:"",
                    NewBlon:false,
                },
                RowType:[],
                RowData:{
                    group: [],
                    gl_file: [],
                },
                PSData:{},//评审数据
                PSBlon:false,
                UserPSData:{},//评审数据
                UserPSBlon:false,
                ShenHeData:{
                    id:"",
                    Blon:false,
                    Val:"1",
                    Remark:"",
                }
            };
        },
        props: ['ApiType','Child'],
        mounted() {
            this.SysType = this.Child[0].id;
            this.GetData();
            this.GetQuery();
            this.GetTypeList();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/dianping/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    system_code:this.ApiType,
                    sq_status:this.StateVal,
                    pingfenSort:this.SortVal,
                    group_id:this.TypeVal,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetTypeList(){
                this.$get('/admin/record/allData',{
                    SystemCode:this.ApiType,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    if(res){
                        this.RowType = res.data.list;
                    }
                })
            },
            GetQuery(){
                this.$get('/admin/auth/system').then(res=>{
                    if(res){
                        this.QueryList = res.data;
                    }
                })
            },
            GetDetail(id){
                this.$get('/admin/dianping/detail',{
                    id:id,
                }).then(res=>{
                    if(res){
                        var Data = JSON.parse(JSON.stringify(res.data));
                        Data.group = Data.group.map(item=>{
                            if (item.field_options && typeof item.field_options === 'string') {
                                try {
                                    item.field_options = JSON.parse(item.field_options);
                                    if(item.field_type == 'checkbox'){item.default_value = item.default_value?item.default_value.split(","):[];}
                                } catch (e) {
                                    item.field_options = [];
                                }
                            }
                            return item;
                        })
                        Data.gl_file = Data.gl_file?Data.gl_file.split(","):[];
                        this.RowData = Data;
                        this.NewData.NewBlon = true;
                    }
                })
            },
            ToggleShenHe(row){
                this.ShenHeData.id = row.id;
                this.ShenHeData.Blon = true;
            },
            ShenHeSuc(){
                this.$post('/online/shenhe',{
                    id:this.ShenHeData.id,
                    is_shenhe:this.ShenHeData.Val,
                    yijian:this.ShenHeData.Remark,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.ShenHeData)
                    }
                })
            },
            LockPS(row){
                this.$get('/admin/final/gradeinfo',{
                    id:row.id,
                }).then(res=>{
                    if(res){
                        this.PSBlon = true;
                        this.PSData = res.data;
                    }
                })
            },
            LockData(row){
                this.NewData.record_name = row.record_name;
                this.GetDetail(row.id)
            },
            WanJieSuc(row){
                this.$confirm('是否确认完结?', '提示', {
                	type: 'warning'
                }).then(() => {
                    this.$post("admin/final/changeStatus",{
                        id:row.id,
                    }).then(res=>{
                        if(res){
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            NoSuc(row){
                this.$prompt('请输入不通过原因', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.$confirm('是否确认提交，确认后此操作不可撤销?', '提示', {
                    	type: 'warning'
                    }).then(() => {
                        this.$post("admin/final/weiguo",{
                          id:row.id,
                          yuanyi:value,
                        }).then(res=>{
                          if(res){
                              this.$message.success(res.msg);
                              this.GetData();
                            }
                        })
                    })
                }).catch(() => {});
            },
            DownFile(id){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/admin/final/export',{
                        id:id,
                    }).then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            ToggleState(row){
                this.$get('/admin/dianping/kai',{
                    id:row.id,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                    }
                })
            },
            ToggleTongBu(row){
                this.$post('/admin/record/userkai',{
                    id:row.id,
                    is_xingshi_user_yj:row.is_xingshi_user_yj,
                    is_online_user_yj:row.is_online_user_yj,
                    is_final_user_yj:row.is_final_user_yj,
                    is_dianping_user_yj:row.is_dianping_user_yj,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                    }
                })
            },
            SendEmail(id){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/admin/online/zjtx',{
                        record_id:id,
                    }).then(res=>{
                        loading.close();
                        if(res){
                            this.$message.success(res.msg);
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            LockUserPs(row){
                this.$get('/admin/record/shenhe',{
                    id:row.id,
                    system_code:this.ApiType,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    if(res){
                        this.UserPSBlon = true;
                        this.UserPSData = res.data;
                    }
                })
            },
            ToggleSysType(id){
                this.SysType = id;
                this.ReSetPage();
                this.GetTypeList();
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .MaxHei{
        max-height: 500px;
        overflow-y: auto;
    }
    .DisFlex{
        display: flex;
        align-items: center;
    }
    .FuJianPos{
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .FuJianAbs{
        position: absolute;
        top: -5px;
        right: -15px;
        font-size: 14px;
        color: #d51938;
    }
    .DigPad{
        padding-left: 10px;
    }
    .BorTop{
        border-top:1px solid #ddd;
        padding-top: 10px;
    }
    .MarLt{
        margin-left: 10px;
    }
    .UserDel{
        color: #f56c6c; 
        cursor: pointer;
    }
    .PSTit{
        padding: 10px 0;
        font-size: 16px;
        font-weight: 700;
    }
    .TongBuDis{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
    }
    .JusRight{
        justify-content: flex-end;
    }
    .TongBuBtn{
        display: inline-block;
    }
</style>
